// extracted by mini-css-extract-plugin
export default {"summary-container":"ManufacturerGroupReportSummary_summary-container__G6WiN","summary-ctas":"ManufacturerGroupReportSummary_summary-ctas__DNtay"};